<script>
    import { mapState } from 'vuex';
    import store from '@/utils/store';

    export default {
        name: 'aside-component',
        data() {
            return {
                is_dark: this.$store.state.isDarkMode,
                isOrderMenuOpen: false,
                mainMenuIsActive: false,
                routerLinkActive: true,
                subRouterLinkActive: false
            }
        },
        computed: {
            ...mapState([
                'isLoggedIn',
                'loggedUser',
                'isOpenAside',
                'isDarkMode'
            ]),
            canMakeOrder() {
                return this.loggedUser.user_roles.some(role => role.id === 1 || role.id === 2 || role.id === 6 || role.id === 10);
            },
        },
        methods: {
            toggleDarkMode() {
                store.commit('setToggleDarkMode', !this.isDarkMode);
            },
            toggleOpenOrderMenu(){
                this.mainMenuIsActive = true;
                this.routerLinkActive = false;
                this.isOrderMenuOpen = !this.isOrderMenuOpen;
            },
            toggleCloseOrderMenu(){
                this.mainMenuIsActive = false;
                this.routerLinkActive = true;
                this.isOrderMenuOpen = false;
            },
            setActiveRoute() {
                let currentRoute =  this.$route.path === '/order/next-step/account' ? '/order/step-one/new' : this.$route.path;
                if (['/orders', '/order/step-one/new'].includes(currentRoute)) {
                    this.mainMenuIsActive = true;
                    this.routerLinkActive = false;
                    this.subRouterLinkActive = currentRoute == '/order/step-one/new' ? true : false;
                    this.isOrderMenuOpen = true;
                } else {
                    this.mainMenuIsActive = false;
                    this.routerLinkActive = true;
                    this.subRouterLinkActive = false;
                    this.isOrderMenuOpen = false;
                }
            }
        },
        watch: {
            '$route.path': function () {
                this.setActiveRoute();
            }
        },
        mounted() {
            this.setActiveRoute();
        }
    };
</script>
